import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CommunityRequestsProvider as Provider } from '../../components/context/community-requests-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const COMMUNITY_REQUESTS_QUERY = graphql`
query NodeAllCommunityRequestsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "CommunityRequests" } }) {
    nodes {
      data
    }
  }
}
`;

export const CommunityRequestsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(COMMUNITY_REQUESTS_QUERY), 'items')}>{children}</Provider>;
};
